import {
  BorderProps,
  ButtonProps,
  ButtonTooltipProps,
  LoadingSpinnerProps,
  PillDropDownProps,
} from 'spindl-shared-components';

import { ErrorIndicatorProps } from '../../molecules/ErrorIndicator';

type TemplateEditorSubNavInternalProps = {
  button?: ButtonProps;
  border?: BorderProps;
  errorIndicator?: ErrorIndicatorProps;
  pillDropDown?: PillDropDownProps;
  buttonTooltip?: ButtonTooltipProps;
  border1?: BorderProps;
  saveButton?: ButtonProps;
  border2?: BorderProps;
  loadingSpinner?: LoadingSpinnerProps;
};

type TemplateEditorSubNavPropsValues = {
  'ErrorDefault': TemplateEditorSubNavInternalProps;
  'NoneDefault': TemplateEditorSubNavInternalProps;
  'NoneLoading': TemplateEditorSubNavInternalProps;
};

const propValues: TemplateEditorSubNavPropsValues = {
  'ErrorDefault': {
    button: {
      type: 'IconTextNoBG',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    errorIndicator: {
    },
    pillDropDown: {
      state: 'Collapsed',
    },
    buttonTooltip: {
    },
    border1: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    saveButton: {
      type: 'Text',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    border2: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
  },
  'NoneDefault': {
    button: {
      type: 'IconTextNoBG',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    pillDropDown: {
      state: 'Collapsed',
    },
    buttonTooltip: {
    },
    border: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    saveButton: {
      type: 'Text',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    border1: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
  },
  'NoneLoading': {
    button: {
      type: 'IconTextNoBG',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    pillDropDown: {
      state: 'Collapsed',
    },
    buttonTooltip: {
    },
    border1: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    saveButton: {
      type: 'Text',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    border2: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    loadingSpinner: {
      size: 'Small',
      styleType: 'Primary',
    },
  },
};

const getProps = (type: string): TemplateEditorSubNavInternalProps => {
  const values: TemplateEditorSubNavInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
